import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section9 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = ["permanent", "temporary"];

    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.employees[category].male) || 0;
      const female = Number(formState.employees[category].female) || 0;
      const total = male + female;

      if (total !== formState.employees[category].total) {
        acc[category] = {
          ...formState.employees[category],
          total
        };
      }
      return acc;
    }, {});

    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      handleChange("employees", "all", updates);
    }
  }, [
    formState.employees.permanent.male,
    formState.employees.permanent.female,
    formState.employees.temporary.male,
    formState.employees.temporary.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ቋሚ ሰራተኞች</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.permanent.male}
                  onValueChange={values => {
                    handleChange("employees", "permanent", {
                      ...formState.employees.permanent,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.permanent.female}
                  onValueChange={values => {
                    handleChange("employees", "permanent", {
                      ...formState.employees.permanent,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.permanent.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ጊዜያዊ ሰራተኞች</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.temporary.male}
                  onValueChange={values => {
                    handleChange("employees", "temporary", {
                      ...formState.employees.temporary,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.temporary.female}
                  onValueChange={values => {
                    handleChange("employees", "temporary", {
                      ...formState.employees.temporary,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.employees.temporary.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(10)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
